import { Logo } from "./Logo";
import { WaIcon } from "./icons";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL, scrollToHash } from "@/lib/constants";

const NAV = [
  { label: "Serviços", hash: "#servicos" },
  { label: "Como funciona", hash: "#como-funciona" },
  { label: "Regiões", hash: "#regioes" },
  { label: "FAQ", hash: "#faq" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-brand-ink pb-28 pt-14 lg:pb-10">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <Logo dark />
          <p className="font-display text-base font-bold text-white">HidroPro Serviços Técnicos</p>
          <p className="mt-2 max-w-xs text-sm leading-relaxed text-white/60">
            Serviços de instalação, manutenção, reparo e adequação de sistemas hidráulicos, bombeamento, aquecimento de
            água e instalações elétricas em São Paulo e região.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-water">Contato</p>
          <a href={PHONE_TEL} data-testid="hidropro-footer-phone-link" className="mt-4 block font-display text-xl font-bold text-white transition-colors hover:text-water">
            {PHONE_DISPLAY}
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hidropro-footer-whatsapp-link"
            className="mt-3 inline-flex items-center gap-2 text-sm text-white/70 transition-colors hover:text-wa"
          >
            <WaIcon className="h-4 w-4" />
            WhatsApp direto
          </a>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-water">Navegação</p>
          <ul className="mt-4 flex flex-col gap-2">
            {NAV.map((n) => (
              <li key={n.hash}>
                <a
                  href={n.hash}
                  data-testid={`hidropro-footer-nav-${n.hash.replace("#", "")}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToHash(n.hash);
                  }}
                  className="text-sm text-white/70 transition-colors hover:text-white"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mx-auto mt-12 flex max-w-7xl flex-col gap-2 border-t border-white/10 px-4 pt-6 sm:px-6 lg:px-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
          Garantia conforme as condições aplicáveis a cada serviço e a legislação vigente
        </p>
        <p className="text-xs text-white/40">© {new Date().getFullYear()} HidroPro Serviços Técnicos. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
}
